const WindowLocationHelper = {
    init: function () {
        const newUrl = new window.Url();

        let fixUrl = false;

        if (newUrl.query['x-auth'] !== undefined) {
            delete newUrl.query['x-auth'];
            fixUrl = true;
        }

        if (fixUrl) {
            if (window.history && typeof window.history.replaceState === 'function') {
                history.replaceState(history.state, window.title, '' + newUrl);
            } else {
                window.location.href = newUrl;
            }
        }
    },
    changeLocation: function (newLocaleCode) {
        const newUrl = new window.Url();

        newUrl.query.lg = newLocaleCode;
        window.location.href = newUrl;
    },
};

export default WindowLocationHelper;
